import React, {Component} from 'react';
import {Field} from 'redux-form';
import * as Form from './formFieldHelpers';
import DateField from '../dates/dateField';
import * as Date from '../dates/dateHelpers';
import * as Buttons from '../ui/buttons';

export default class PublicationForm extends Component {
    componentDidMount() {
        this.handleInitialise();
    }

    handleInitialise = () => {
        const {personId, initialize, id, title, publisher, author, url, description, publication_date, person_id, publications} = this.props;

        const month = Date.handleSingleDate(publication_date).month;
        const initialValues = {
            "type": id ? 'UPDATE' : 'CREATE',
            "id": id,
            "person_id": +personId || +person_id || publications.personId,
            "title": title,
            "publisher": publisher,
            "author": author,
            "url": url,
            "description": description,
            "year": { label: Date.handleSingleDate(publication_date).year, value: Date.handleSingleDate(publication_date).year },
          "month": {label: month && month.name, value: month && month.id},
        };
        initialize(initialValues);
    };

    render() {
        const {buttonHandlers, publication_date, handleCancel, handleAdding } = this.props;
        return (
            <form className="form-standard-profile">
                <div className="row">
                    <div className="col-xs-12 col-md-6">
                        <Field
                            label="Title"
                            name="title"
                            placeholder="Title"
                            component={ Form.textField }
                        />
                    </div>
                    <div className="col-xs-12 col-md-6">
                        <Field
                            label="Publisher"
                            name="publisher"
                            placeholder="Publisher"
                            component={ Form.textField }
                        />
                    </div>
                    <div className="col-xs-12 col-md-6">
                        <Field
                            label="Author"
                            name="author"
                            placeholder="Author"
                            component={ Form.textField }
                        />
                    </div>
                    <div className="col-xs-12">
                        <Field
                            label="Url"
                            name="url"
                            placeholder="http://www..."
                            component={ Form.textField }
                        />
                    </div>

                    <div className="col-xs-12">
                        <DateField date={publication_date}/>
                    </div>

                    <div className="col-xs-12">
                        <Field
                            label="Description"
                            name="description"
                            placeholder="Description."
                            component={ Form.quill }
                        />
                    </div>
                </div>
                <Buttons.HOCFormButtons
                    { ... buttonHandlers }
                    { ...this.props }
                    handleCancel={ handleCancel }
                    handleAdding={ form => handleAdding( form ) } />
            </form>
        )
    }
}




// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/forms/PublicationForm.js